import React from 'react';
import IBackdrop from './IBackdrop';
import * as style from './BackdropStyle.module.scss'



const Backdrop: React.SFC<IBackdrop> = (props) => {
  return (
    props.show ? <div className={style.backdrop} /> : null
  );
};

export default Backdrop;
